module.exports = __webpack_public_path__ + "static/media/notification.6fe77d61.svg";